var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkMusic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125,
    height: 27,
    viewBox: "0 0 125 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1759",
    "data-name": "Group 1759",
    transform: "translate(-832 -470)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Items",
    transform: "translate(863 490)",
    fill: "#02071a",
    fontSize: 19,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600,
    letterSpacing: "-0.048em",
    opacity: 0.724
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Link music")), /*#__PURE__*/React.createElement("path", {
    id: "Path_1629",
    "data-name": "Path 1629",
    d: "M12,3l.01,10.55A3.995,3.995,0,1,0,14,17V7h4V3ZM10.01,19a2,2,0,1,1,2-2A2.006,2.006,0,0,1,10.01,19Z",
    transform: "translate(826 472)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkMusic);
export default __webpack_public_path__ + "static/media/link-music.d24150f6.svg";
export { ForwardRef as ReactComponent };